export class ClaudeEnterpriseKeyCheck {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "check",
            "baseName": "check",
            "type": "ClaudeEnterpriseKeyCheckName",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "ClaudeEnterpriseKeyCheckStatus",
            "format": ""
        },
        {
            "name": "errorMessage",
            "baseName": "errorMessage",
            "type": "string",
            "format": ""
        },
        {
            "name": "apiStatusCode",
            "baseName": "apiStatusCode",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ClaudeEnterpriseKeyCheck.attributeTypeMap;
    }
    constructor() {
    }
}
